import React, { useState, useRef } from 'react';

function SingleAudio({ src, label, onPlayRequest, onPauseGlobal }) {
    const audioRef = React.useRef(null);
    const containerRef = React.useRef(null);

    const getIcon = () =>
        containerRef.current.querySelector(".audio-icon");

    const handleToggle = () => {
        const audio = audioRef.current;
        const icon = getIcon();
        if (!audio) return;

        // Andere Audios stoppen
        onPlayRequest(audio);

        // Play → Pause Status wechseln
        if (audio.paused) {
            audio.currentTime = 0;    // immer von Anfang
            audio.play();
            icon.src = "/img/pause-icon.svg";
            icon.alt = "Pause";
        } else {
            audio.pause();
            audio.currentTime = 0;
            audio.load();             // zurücksetzen
            icon.src = "/img/play-icon.svg";
            icon.alt = "Play";
        }
    };

    const handleEnded = () => {
        const icon = getIcon();
        icon.src = "/img/play-icon.svg";
        icon.alt = "Play";
    };

    return (
        <div className="audio-button" ref={containerRef}>
            <p>{label}</p>

            {/* 👇 DEIN eigener Button, ersetzt das Audio-Control */}
            <button className="play-btn" onClick={handleToggle}>
                <img className="audio-icon" src="/img/play-icon.svg" alt="Play" />
            </button>

            {/* 👇 Audio ohne native Buttons */}
            <audio
                ref={audioRef}
                src={src}
                onEnded={handleEnded}
            />
        </div>
    );
}
export default SingleAudio;